import React from 'react';
import { I18nProvider } from '../I18nProvider/I18nProvider.es.js';
import { useNavBarContext, NavBarContext } from './NavBarContext.es.js';

var useNavBarLocation = function useNavBarLocation() {
  var _context$locationPath;
  var context = useNavBarContext();
  return {
    pathname: (_context$locationPath = context.locationPathname) !== null && _context$locationPath !== void 0 ? _context$locationPath : '',
    hostname: typeof window !== 'undefined' ? window.location.hostname : '',
    protocol: typeof window !== 'undefined' ? window.location.protocol : '',
    host: typeof window !== 'undefined' ? window.location.host : ''
  };
};
var NavBarProvider = function NavBarProvider(_ref) {
  var children = _ref.children,
    env = _ref.env,
    language = _ref.language,
    onLogin = _ref.onLogin,
    onLogout = _ref.onLogout,
    user = _ref.user,
    hasNotifications = _ref.hasNotifications,
    isSessionsPickerVisible = _ref.isSessionsPickerVisible,
    isUserLoading = _ref.isUserLoading,
    chatClientService = _ref.chatClientService,
    locationPathname = _ref.locationPathname,
    config = _ref.config,
    hasDesktopNotifications = _ref.hasDesktopNotifications,
    isJobsRevampPagesVisible = _ref.isJobsRevampPagesVisible;
  return /*#__PURE__*/React.createElement(NavBarContext.Provider, {
    value: {
      env: env,
      onLogin: onLogin,
      onLogout: onLogout,
      user: user,
      language: language,
      hasNotifications: hasNotifications,
      chatClientService: chatClientService,
      isSessionsPickerVisible: isSessionsPickerVisible,
      isUserLoading: isUserLoading,
      config: config,
      locationPathname: locationPathname,
      hasDesktopNotifications: hasDesktopNotifications,
      isJobsRevampPagesVisible: isJobsRevampPagesVisible
    }
  }, /*#__PURE__*/React.createElement(I18nProvider, null, children));
};

export { NavBarProvider, useNavBarLocation };
